<div class="tax-container">
    <header>
        <nav-bar></nav-bar>
        <div class="header-wrapper">
            <div class="banner-wrapper">
                <div class="banner landing">
                    <div class="intro-block">
                        <p class="sub-title">Tax Certification Portal</p>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main id="main">
        <div class="content-wrapper">
            <div class="content">
                <article class="main">
                    <h1>Invalid Link</h1>
                    <p>We're sorry, but the link you've used to access this website is not valid.</p>
                    <p>To access this website, please use the link provided to you by your broker.</p>
                </article>
            </div>
        </div>
    </main>
    <footer-bar></footer-bar>
</div>
